export const BENCHED = '-' as const
export const defaultNumPeriods = 4 as const
export const NULL_NETSTAT_VALUE = -1.25 as const
export const PREFS_REQUIRE = 'Require' as const

const fieldPositions = [
	'GS', 'GA', 'WA', 'C', 'WD', 'GD', 'GK',
] as const
const fieldPositions_6ASideNoWD = [
	'GS', 'GA', 'WA', 'C', 'GD', 'GK',
] as const
const fieldPositions_Fast5 = [
	'GS', 'GA', 'C', 'GD', 'GK',
] as const
const fieldPositions_6ASide = [
	'A', 'A', 'C', 'C', 'D', 'D',
] as const
const fieldPositions_5ASide = [
	'A', 'A', 'C', 'D', 'D',
] as const

export const queryFieldPositions = (gameFormat: GameFormat) => {
	switch (gameFormat) {
		case 4: return fieldPositions_Fast5
		case 5: return fieldPositions_5ASide
		case 6: return fieldPositions_6ASide
		case 8: return fieldPositions_6ASideNoWD
		default: return fieldPositions
	}
}

export const queryMaxIdealPositions = (numPeriods: number, gameFormat: GameFormat) => {
	return Math.min(numPeriods, new Set(queryFieldPositions(gameFormat)).size)
}
